import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { ImportFileComponent } from './import-file/import-file.component';
import { LocationLogsComponent } from './location-logs/location-logs.component';
import { CallLogsComponent } from './call-logs/call-logs.component';
import { DialerCallLogsComponent } from './dialer-call-logs/dialer-call-logs.component';
import { RutCallLogComponent } from './rut-call-log/rut-call-log.component';
import { LocationLogsTableCellComponent } from './location-logs/location-logs-table-cell.component';
import { CallLogsTableCellComponent } from './call-logs/call-logs-table-cell.component';
import { TmoLocationLogsComponent } from './tmo-location-logs/tmo-location-logs.component';
import { TmoLocationLogsTableCellComponent } from './tmo-location-logs/tmo-location-logs-table-cell.component'
import { ImportFileListComponent } from './import-file-list/import-file-list.component';
import { ImportFilePanelComponent } from './import-file-panel/import-file-panel.component';
import { CorrelationTableComponent } from './correlation-table/correlation-table.component';
import { CorrelationTableCellComponent } from './correlation-table/correlation-table-cell.component';
import { CorrelationDashboardTableComponent } from './correlation-dashboard/correlation-dashboard-table.component';
import { CorrelationSummaryComponent } from './correlation-summary/correlation-summary.component';
import { MergedExcelConfirmationModalComponent } from './correlation-dashboard/merged-excel-confirmation-modal.component';
import { ExcelDateRangeModalComponent } from './correlation-dashboard/excel-date-range-modal.component';
import { SharedModule } from '../shared/shared.module';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { DialerCallLogsTableComponent } from './dialer-call-logs/dialer-call-logs-table.component';
import { RutCallLogTableComponent } from './rut-call-log/rut-call-log-table.component';
import { HandsetTableCellComponent } from './handset-table/handset-table-cell.component';
import { HandsetTableComponent } from './handset-table/handset-table.component';
import { MissingHandsetTableCellComponent } from './missing-handset-table/missing-handset-table-cell.component';
import { MissingHandsetTableComponent } from './missing-handset-table/missing-handset-table.component';
import { NgPipesModule } from 'ngx-pipes';
import { CorrelationDashboardComponent } from './correlation-dashboard/correlation-dashboard.component';
import { RutCallPhotosComponent } from './rut-call-photos/rut-call-photos.component';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { PathModule } from '../path/path.module';
import { DragDropModule } from '@angular/cdk/drag-drop';

@NgModule({
  declarations: [
    ImportFileComponent,
    LocationLogsComponent,
    CallLogsComponent,
    DialerCallLogsComponent,
    LocationLogsTableCellComponent,
    CallLogsTableCellComponent,
    DialerCallLogsTableComponent,
    TmoLocationLogsComponent,
    TmoLocationLogsTableCellComponent,
    ImportFileListComponent,
    ImportFilePanelComponent,
    CorrelationTableComponent,
    CorrelationDashboardTableComponent,
    CorrelationSummaryComponent,
    CorrelationTableComponent,
    CorrelationTableCellComponent,
    HandsetTableComponent,
    HandsetTableCellComponent,
    MissingHandsetTableComponent,
    MissingHandsetTableCellComponent,
    CorrelationDashboardComponent,
    RutCallLogTableComponent,
    RutCallLogComponent,
    RutCallPhotosComponent,
    MergedExcelConfirmationModalComponent,
    ExcelDateRangeModalComponent,
  ],
  imports: [
    SharedModule,
    CommonModule,
    FormsModule,
    NgPipesModule,
    PathModule,
    DragDropModule,
    PaginationModule.forRoot(),
    PopoverModule.forRoot(),
    BsDropdownModule.forRoot(),
  ],
  exports: [
    LocationLogsComponent,
    CallLogsComponent,
    DialerCallLogsComponent,
    LocationLogsTableCellComponent,
    CallLogsTableCellComponent,
    DialerCallLogsTableComponent,
    TmoLocationLogsComponent,
    TmoLocationLogsTableCellComponent,
    ImportFilePanelComponent,
    CorrelationTableComponent,
    CorrelationTableCellComponent,
    CorrelationDashboardComponent,
    CorrelationSummaryComponent,
    HandsetTableComponent,
    HandsetTableCellComponent,
    MissingHandsetTableComponent,
    MissingHandsetTableCellComponent,
    RutCallLogComponent,
    RutCallLogTableComponent,
  ]
})
export class PostProcessingModule {}
